import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  static targets = ['notifierBody', 'switchButton', 'submitButton']

  connect() {
    $(this.notifierBodyTarget).modal('show')
    $('.selectpicker').selectpicker();
  }

  handleWorkflowSelect(e) {
    const workflowDefinitionId = e.target.value
    const url = `/notifier/notifications/show_associated_contacts?workflow_definition_id=${workflowDefinitionId}`

    Turbo.visit(url, { action: 'replace', frame: 'notifier_specimen_body_notifier_contacts'})
  }

  handleSubmit(e) {
    e.preventDefault()
    $('#notifierForm').submit()
  }

  async handleBack(e) {
    const accessionId = e.target.dataset.accessionid
    const location = e.target.dataset.location
    const url = `/notifier/notifications/show_notifier?accession_id=${accessionId}&location=${location}`
    const response = await axios.get(url)
    if (response.status === 200) {
      const responseBody = response.data
      const newDocument = new DOMParser().parseFromString(responseBody, 'text/html')
      const newFrame = newDocument.querySelector('turbo-frame#notifier_specimen_body')
      const currentFrame = document.querySelector('turbo-frame#notifier_specimen_body')
      currentFrame.replaceWith(newFrame)
      $('.selectpicker').selectpicker();
      $('#notifierForm').validate({
        ignore: [],
        rules: {"accession[specimen_test_schedule_id]": {required: true},
                "accession[workflow_definition_id]": {required: true},
                "accession[email_addresses]": {validateEmailList: true},
                "accession[call_numbers]": {validatePhoneWithExtList: true},
                "accession[text_numbers]": {validatePhoneList: true}
                },
        errorPlacement: function(error, element) {
          error.insertAfter(element.parent());
        }
      });
    }
  }

  handleSelectAll(e) {
    const checked = e.target.checked
    if (e.target.id === 'select_email') {
      const checkboxes = document.querySelectorAll('.email_nc_checkbox')
      checkboxes.forEach(checkbox => checkbox.checked = checked)
    } else {
      const checkboxes = document.querySelectorAll('.phone_nc_checkbox')
      checkboxes.forEach(checkbox => checkbox.checked = checked)
    }
  }

  handleSelectNotif(e) {
    const el = e.target
    const parent1 = el.parentNode
    const parent2 = parent1.parentNode
    let notifId

    const currentlySelected = document.querySelector('.active')
    const activeSpinner = document.querySelector('.active-spinner')
    const errorContainer = document.getElementById('notification-error')

    const toggleSelectedNotif = (el) => {
      if (currentlySelected) currentlySelected.classList.remove('active')
      if (currentlySelected && el.dataset.notificationId === currentlySelected.dataset.notificationId) {
        el.classList.remove('active')
        document.querySelector('.details_' + currentlySelected.dataset.notificationId).innerHTML = '' // Clear the details container
      } else {
        el.classList.add('active')
      }
      notifId = el.dataset.notificationId
    }

    if (el.classList.contains('list-group-item')) {
      toggleSelectedNotif(el)
    } else if (parent1.classList.contains('list-group-item')) {
      toggleSelectedNotif(parent1)
    } else if (parent2.classList.contains('list-group-item')) {
      toggleSelectedNotif(parent2)
    }

    if (currentlySelected && notifId === currentlySelected.dataset.notificationId) return

    const detailsContainer = document.querySelector('.details_' + notifId)

    let spinner = document.createElement('div')
    spinner.classList.add('spinner-border', 'spinner-border-lg', 'my-5', 'mx-auto', 'd-block', 'active-spinner')

    detailsContainer.appendChild(spinner)
    if (activeSpinner) activeSpinner.parentElement.innerHTML = ''

    const showError = () => {
      errorContainer.classList.remove('d-none')
      if (detailsContainer) detailsContainer.innerHTML = ''
    }

    const getStatus = (id) => {
      axios.get(`/notifier/notifications/${id}/status`)
      .then(response => {
        const data = response.data
        const oldDetails = document.getElementById('notification_detail')
        if (oldDetails) {
          oldDetails.innerHTML = ''
          oldDetails.id = ''
        }
        if (data.success) {
          detailsContainer.innerHTML = data.html
        } else {
          showError()
        }
      })
      .catch(error => {
        showError(error)
      })
    }

    getStatus(notifId)
  }

  handlePrintNotif(e) {
    e.stopPropagation()
    const el = e.target
    const notifId = el.dataset.printId

    const createPrintWindow = (notifData) => {
      // Open a new window and add the notification info
      let view = window.open()
      let title = document.createElement('h1')
      let subtitle = document.createElement('h5')
      let br = document.createElement('br')
      let notificationList = document.createElement('ul')

      // Create print page title and subtitle
      let titleValue = document.querySelector(`.notif_title_${notifId}`)
      let sentBy = document.querySelector(`.notif_sent_by_${notifId}`)

      // Set print page title and subtitle to created elements
      title.innerHTML = titleValue.textContent
      subtitle.innerHTML = notifData[notifData.length - 1].Timestamp
      subtitle.appendChild(br)
      subtitle.innerHTML += sentBy.textContent

      // Iterate through the updates and create a list of them
      for (let update of notifData) {
        let li = document.createElement('li')
        let p = document.createElement('p')
        li.innerHTML = update.Details
        p.innerHTML = update.Timestamp
        p.style.marginLeft = '1em'
        li.style.fontWeight = 'bold'
        p.style.fontWeight = 'lighter'
        li.appendChild(p)
        notificationList.appendChild(li)
      }

      // Align the list items to the left
      notificationList.style.display = 'inline-block'
      notificationList.style.textAlign = 'left'

      // Append the data to the new print page
      view.document.body.appendChild(title)
      view.document.body.appendChild(subtitle)
      view.document.body.appendChild(notificationList)
      view.document.body.style.textAlign = 'center'
      view.document.title = 'Coreone For Labs'

      // Print the page
      view.print()
    }

    axios.get(`/notifier/notifications/${notifId}/print_notification`)
    .then(response => {
      const data = response.data
      if (data.success) {
        createPrintWindow(data.notif_status)
      }
    })
  }
}